import { z } from 'zod';
import { PartnerNewsAdminSchema } from '../../entities/partner-news/partner-news.schema';
/**
 * Delete Partner News Image
 * DELETE /api/v2/admin/partner-news/:id/images/:slot
 */ export const DeletePartnerNewsImageResponseSchema = z.object({
    data: PartnerNewsAdminSchema
});

//# sourceMappingURL=delete-partner-news-image.schema.js.map